import React from 'react';
import { iconMap } from '../shared/icons';

const Hero = ({ theme, business }) => (
  <div style={{
    background: theme.logo?.background
      ? `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${theme.logo.background}) center/cover`
      : theme.colors.primary,
    color: theme.colors.background,
    padding: '80px 20px',
    textAlign: 'center'
  }}>
    <div style={{
      backgroundColor: 'rgba(40,40,40,0.7)',
      padding: '40px',
      borderRadius: theme.borderRadius.lg,
      backdropFilter: 'blur(10px)',
      display: 'inline-block'
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        gap: '15px', marginBottom: '20px'
      }}>
        {theme.logo?.image ? (
          <img
            data-field="logo" data-path="theme.logo.image"
            src={theme.logo.image} alt={theme.name}
            style={{ width: '300px' }}
          />
        ) : theme.logo?.icon && iconMap[theme.logo.icon] ? (
          React.createElement(iconMap[theme.logo.icon], { size: 64 })
        ) : (
          <span style={{ fontSize: '4rem' }}>{theme.logo?.text}</span>
        )}
      </div>
      <p data-field="tagline" style={{
        fontSize: '1.4rem', margin: '0 0 20px 0', lineHeight: '1.6',
        color: '#ffffff', textAlign: 'center', fontStyle: 'italic'
      }}>
        {theme.tagline}
      </p>
      <p data-field="description" style={{
        fontSize: '1.1rem', margin: 0, lineHeight: '1.6',
        color: 'rgba(255,255,255,0.9)', textAlign: 'center', maxWidth: '600px'
      }}>
        {business.description || theme.description}
      </p>
    </div>
  </div>
);

export default Hero;
